import React, { useEffect, useState, useRef } from 'react';
import { SparklesIcon, InstagramIcon, FacebookIcon, YoutubeIcon, XIcon } from 'lucide-react';
export function Footer() {
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  // Close tooltip when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setActiveTooltip(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const policyContent = {
    terms: <div data-id="element-51">
        <h3 className="text-lg font-bold mb-2" data-id="element-52">Términos y Condiciones</h3>
        <p className="mb-2" data-id="element-53">
          Al acceder a este curso, aceptas los siguientes términos:
        </p>
        <ul className="list-disc pl-5 mb-2" data-id="element-54">
          <li data-id="element-55">El contenido es solo para uso personal</li>
          <li data-id="element-56">No está permitida la redistribución del material</li>
          <li data-id="element-57">El acceso es de por vida a la versión actual</li>
          <li data-id="element-58">Las actualizaciones futuras pueden tener costo adicional</li>
        </ul>
      </div>,
    privacy: <div data-id="element-59">
        <h3 className="text-lg font-bold mb-2" data-id="element-60">Política de Privacidad</h3>
        <p className="mb-2" data-id="element-61">Respetamos tu privacidad:</p>
        <ul className="list-disc pl-5 mb-2" data-id="element-62">
          <li data-id="element-63">Solo recolectamos datos necesarios para tu cuenta</li>
          <li data-id="element-64">No compartimos tus datos con terceros</li>
          <li data-id="element-65">Usamos cookies para mejorar tu experiencia</li>
          <li data-id="element-66">Puedes solicitar la eliminación de tus datos</li>
        </ul>
      </div>,
    contact: <div data-id="element-67">
        <h3 className="text-lg font-bold mb-2" data-id="element-68">Contacto</h3>
        <p className="mb-2" data-id="element-69">Estamos aquí para ayudarte:</p>
        <ul className="list-disc pl-5 mb-2" data-id="element-70">
          <li data-id="element-71">Email: soporte@nailmasterclass.com</li>
          <li data-id="element-72">WhatsApp: +123 456 7890</li>
          <li data-id="element-73">Horario: Lunes a Viernes, 9am - 6pm</li>
        </ul>
      </div>
  };
  return <footer className="bg-gray-900 text-white py-12 px-4" data-id="element-74">
      <div className="container mx-auto max-w-6xl" data-id="element-75">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-76">
          <div className="flex items-center mb-4 md:mb-0" data-id="element-77">
            <SparklesIcon className="h-6 w-6 text-pink-500 mr-2" data-id="element-78" />
            <span className="text-xl font-bold" data-id="element-79">Nail Masterclass Pro</span>
          </div>
          <div className="flex space-x-4" data-id="element-80">
            <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-81">
              <InstagramIcon className="h-5 w-5" data-id="element-82" />
            </a>
            <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-83">
              <FacebookIcon className="h-5 w-5" data-id="element-84" />
            </a>
            <a href="#" className="hover:text-pink-400 transition-colors" data-id="element-85">
              <YoutubeIcon className="h-5 w-5" data-id="element-86" />
            </a>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 pb-4" data-id="element-87">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-88">
            <p className="text-gray-400 mb-4 md:mb-0" data-id="element-89">
              &copy; {new Date().getFullYear()} Nail Masterclass Pro. Todos los
              derechos reservados.
            </p>
            <div className="flex space-x-6 relative" data-id="element-90">
              <button onClick={() => setActiveTooltip(activeTooltip === 'terms' ? null : 'terms')} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-91">
                Términos y Condiciones
              </button>
              <button onClick={() => setActiveTooltip(activeTooltip === 'privacy' ? null : 'privacy')} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-92">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveTooltip(activeTooltip === 'contact' ? null : 'contact')} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-93">
                Contacto
              </button>
              {activeTooltip && <div ref={tooltipRef} className="absolute bottom-full mb-2 right-0 w-80 bg-white text-gray-800 rounded-lg shadow-xl p-4 z-50" data-id="element-94">
                  <button onClick={() => setActiveTooltip(null)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" data-id="element-95">
                    <XIcon className="h-4 w-4" data-id="element-96" />
                  </button>
                  {policyContent[activeTooltip as keyof typeof policyContent]}
                </div>}
            </div>
          </div>
        </div>
      </div>
    </footer>;
}